export const dashboardAreaData = [
  {
    name: "Jan",
    uv: 120000, // Totale claimkosten
  },
  {
    name: "Feb",
    uv: 135000,
  },
  {
    name: "Mar",
    uv: 160000,
  },
  {
    name: "Apr",
    uv: 175000,
  },
  {
    name: "Mei",
    uv: 210000,
  },
  {
    name: "Jun",
    uv: 250000,
  },
  {
    name: "Jul",
    uv: 195000,
  },
  {
    name: "Aug",
    uv: 180000,
  },
  {
    name: "Sep",
    uv: 160000,
  },
  {
    name: "Okt",
    uv: 0,
  },
  {
    name: "Nov",
    uv: 0,
  },
  {
    name: "Dec",
    uv: 0,
  },
];
